import { ActionIcon, Combobox, Group, useCombobox } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import EnFlagIcon from '../icons/en-flag';
import FrFlagIcon from '../icons/fr-flag';
import RoFlagIcon from '../icons/ro-flag';

import styles from './lang-select.module.css';

interface Item {
  value: 'fr' | 'en' | 'ro';
  label: string;
}

const icons = {
  fr: (
    <FrFlagIcon
      className={styles['flag-icon']}
      style={{ width: '100%', height: '100%' }}
    />
  ),
  en: (
    <EnFlagIcon
      className={styles['flag-icon']}
      style={{ width: '100%', height: '100%' }}
    />
  ),
  ro: (
    <RoFlagIcon
      className={styles['flag-icon']}
      style={{ width: '100%', height: '100%' }}
    />
  ),
};


export const LangSelect = () => {
  const { i18n, t } = useTranslation();
  const [value, setValue] = useState<string>(i18n.language);
  const langData: Item[] = [
    { value: 'fr', label: t('common.languages.fr') },
    { value: 'en', label: t('common.languages.en') },
    { value: 'ro', label: t('common.languages.ro') },
  ];
  const selectedOption = langData.find((item) => item.value === value);

  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const options = langData
    .filter((item) => item.value !== value)
    .map((item) => (
      <Combobox.Option
        className={styles['option']}
        key={item.value}
        value={item.value}
      >
        <div className={styles['option-inner']}>
          <Group>{icons[item.value]}</Group>
        </div>
      </Combobox.Option>
    ));

  useEffect(() => {
    i18n.changeLanguage(value);
  }, [i18n, value]);

  return (
    <Combobox
      onOptionSubmit={(val) => {
        setValue(val);
        combobox.closeDropdown();
      }}
      store={combobox}
    >
      <Combobox.Target>
        {selectedOption ? (
          <ActionIcon
            aria-label={selectedOption.label}
            className={styles['flag-action-icon']}
            onClick={() => combobox.toggleDropdown()}
            radius="xl"
            size="lg"
            variant="default"
          >
            {icons[selectedOption.value]}
          </ActionIcon>
        ) : (
          <div />
        )}
      </Combobox.Target>

      <Combobox.Dropdown className={styles.dropdown}>
        <Combobox.Options>{options}</Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};

export default LangSelect;
